import { useGlobal } from '../context/GlobalContext';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import api from '../api/axios';
import { formatProductData } from '../helper/formatProductData';

const NewArrivalTwo = (props) => {
    const { addToCart, cartItems, wishlistItems, addToWishlist, removeFromWishlist } = useGlobal();
    const location = useLocation();
    const { id } = useParams();
    const productId = id ? id : (location.state?.id || "1");

    const [productsData, setProductsData] = useState([]);
    const [relatedProducts, setRelatedProducts] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await api.get('/api/products');
                const formatted = response.data.map(formatProductData);
                setProductsData(formatted);
            } catch (err) {
                console.error("Failed to fetch related products", err);
            }
        };
        fetchProducts();
    }, []);

    useEffect(() => {
        if (!productsData.length) return;

        const currentProduct = productsData.find((p) => p.id === productId) || productsData[0];
        const currentCategory = currentProduct?.category;

        let related = productsData.filter(
            (p) => p.category === currentCategory && p.id !== productId
        );

        if (related.length < 5) {
            const otherProducts = productsData.filter(
                (p) => p.category !== currentCategory && p.id !== productId
            );
            const needed = 5 - related.length;
            related = [...related, ...otherProducts.slice(0, needed)];
        }
        setRelatedProducts(related);
    }, [productsData, productId]);

    const isInfinite = relatedProducts.length > 5;

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: isInfinite,
        speed: 500,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        slidesToShow: 5,
        slidesToScroll: 2,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">You Might Also Like</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Products
                            </Link>
                        </div>
                    </div>
                </div>
                <style>{`
                    .new-arrival__slider .slick-list {
                        margin: 0 -10px;
                    }
                    .new-arrival__slider .product-card__cart {
                        white-space: nowrap;
                    }
                    @media (max-width: 576px) {
                        .new-arrival__slider .product-card__cart {
                            padding: 8px 12px !important;
                            font-size: 12px !important;
                            gap: 4px !important;
                        }
                    }
                `}</style>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {relatedProducts.map((product, index) => {
                            const isInCart = cartItems?.some(item => String(item.id) === String(product.id));
                            const isWishlisted = wishlistItems?.some(item => String(item.id) === String(product.id));
                            return (
                            <div key={index}>
                                <div className="product-card p-12 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 d-flex flex-column" style={{ aspectRatio: '1', width: '100%' }}>
                                    {/* Wishlist Heart Button */}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (isWishlisted) {
                                                removeFromWishlist(product.id);
                                            } else {
                                                addToWishlist(product);
                                            }
                                        }}
                                        className={`pl-wishlist-btn border ${
                                            isWishlisted
                                                ? 'bg-danger-50 border-danger-200 text-danger-600'
                                                : 'bg-white border-gray-100 text-gray-400 hover-text-main-600 hover-border-main-600 shadow-xs'
                                        }`}
                                        title={isWishlisted ? "In Wishlist (Click to remove)" : "Add to Wishlist"}
                                        aria-label="Wishlist"
                                    >
                                        <i className={`${isWishlisted ? 'ph-fill ph-heart text-danger-600' : 'ph ph-heart'} text-base`} />
                                    </button>

                                    <Link
                                        to={`/product-details/${product.slug || product.id}`}
                                        className="product-card__thumb flex-center"
                                        style={{ flex: '1 1 auto', minHeight: 0 }}
                                    >
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            style={{ width: '100%', height: '100%', maxWidth: '120px', maxHeight: '120px', objectFit: 'contain' }}
                                        />
                                    </Link>
                                    <div className="product-card__content mt-8 flex-shrink-0 d-flex flex-column" style={{ flex: '0 0 auto' }}>
                                        <h6 className="title text-md fw-semibold mb-8">
                                            <Link to={`/product-details/${product.slug || product.id}`} className="link text-line-2">
                                                {product.name}
                                            </Link>
                                        </h6>
                                        <div className="product-card__price mb-8 flex-align gap-8 flex-wrap justify-content-start">
                                            <div className="d-flex align-items-center gap-6 flex-wrap">
                                                <span className="text-heading text-md fw-semibold">
                                                    {product.currentPrice} <span className="text-gray-500 fw-normal text-xs">{product.quantityText}</span>
                                                </span>
                                                {product.originalPrice && (
                                                    <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through">
                                                        {product.originalPrice}
                                                    </span>
                                                )}
                                            </div>
                                            {product.rawVariants && product.rawVariants.length > 1 && (
                                                <span
                                                    className="badge rounded-4 fw-medium"
                                                    style={{
                                                        fontSize: '10px',
                                                        color: '#4b5563',
                                                        background: '#f3f4f6',
                                                        border: '1px solid #e5e7eb',
                                                        padding: '1px 5px',
                                                        whiteSpace: 'nowrap',
                                                        flexShrink: 0
                                                    }}
                                                    title={`${product.rawVariants.length} options available`}
                                                >
                                                    +{product.rawVariants.length} options
                                                </span>
                                            )}
                                        </div>

                                        {isInCart ? (
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-600 text-white hover-bg-main-700 py-11 px-24 rounded-pill flex-align gap-8 w-100 justify-content-center text-sm"
                                            >
                                                View Cart <i className="ph ph-shopping-cart" />
                                            </Link>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={(e) => { e.preventDefault(); addToCart(product, 1, product.defaultVariant || ((product.rawVariants && product.rawVariants.length > 0) ? product.rawVariants[0] : null)); }}
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 w-100 justify-content-center text-sm"
                                            >
                                                Add to Cart <i className="ph ph-shopping-cart" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                        })}
                    </Slider>
                </div>
            </div>
        </section>

    )
}

export default NewArrivalTwo;
